/** @format */

import HeaderSquares from "./assets/images/Header_Squares.svg?react";
import React from "react";
import { LocaleSwitch } from "./LocaleSwitch";
import { UserWidget } from "./UserWidget";
import { useTranslation } from "react-i18next";
import { useBrand } from "../../hooks/useBrand";
import Logo from "./assets/Header_Logo.svg?react";

interface HeaderProps {
	appTitle: string;
	appIcon?: React.FC<{ className?: string }>;
}
export const Header = ({ appTitle, appIcon }: HeaderProps) => {
	const { i18n } = useTranslation();
	const { brand } = useBrand();
	const AppIcon = appIcon;

	return (
		<header className="relative shrink-0 z-40 flex flex-row w-full px-10 bg-white min-h-16 border-b border-[#bbb] items-center justify-between overflow-hidden">
			<div className="min-w-0 flex items-center gap-3 mr-4">
				<h1 className="wrap-break-word font-bold text-xl md:text-3xl">{appTitle}</h1>
				{AppIcon && <AppIcon className="h-8" />}
			</div>

			<HeaderSquares className="absolute left-1/2 -translate-x-1/2 h-18 pointer-events-none" />

			<div className="relative z-10 flex flex-row gap-2 md:gap-5 items-center pt-2 pb-1">
				{brand === "wjec" && <LocaleSwitch />}
				<UserWidget />
				<Logo className={i18n.language === "cy" ? "cy" : ""} />
			</div>
		</header>
	);
};
